module.exports = __webpack_public_path__ + "img/1526694354.cbc22220.jpg";